
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import AppExtraFieldsEditModal from "@/components/ExtraFieldsEditModal.vue";
import Vue from "vue";
import SaleRowExtraFields from "@/models/base/sale-row-extra-fields";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	data(){
		return {
			toEditExtraFields: null as null | SaleRowExtraFields,
			DossierConfigService
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		settings():ExtraFieldNamesConfig{
			return this.DossierConfigService.getExtraFieldNamesConfigs().SaleRowNames;
		},
		isOpen():boolean{
			return this.toEditExtraFields!==null;
		}
	},
	watch: {
		"state.toEditRowExtraFields": {
			immediate: true,
			handler(){
				if (!this.state.toEditRowExtraFields) {
					this.toEditExtraFields = null;
					return;
				}
				this.toEditExtraFields = new SaleRowExtraFields(this.state.toEditRowExtraFields.ExtraFields?.getJSON() || null);
			},
		}
	},
	methods: {
		close(){
			this.state.toEditRowExtraFields = null;
		},
		onUpdate(){
			if (!this.toEditExtraFields) return this.close();
			if (!this.state.toEditRowExtraFields) return this.close();
			if (this.toEditExtraFields.hasValues()) {
				this.state.toEditRowExtraFields.ExtraFields = this.toEditExtraFields;
			}else{
				this.state.toEditRowExtraFields.ExtraFields = null;
			}
			this.close();
		}
	},
	components: {
		AppExtraFieldsEditModal
	}
});
